export function renderPageImportsTemplate({
  pascal,
  kebab
}: {
  pascal: string
  kebab: string
}): string {
  return `import { getSetting } from '@admin/actions/settings'
import * as React from 'react'
import { ${pascal}SubmissionsPageContent } from './${kebab}-submissions-page-content'
import { ${pascal}SubmissionsPageSkeleton } from './${kebab}-submissions-page-skeleton'

export default async function Page() {
  const initialSettings = await getSetting()

  return (
    <React.Suspense fallback={<${pascal}SubmissionsPageSkeleton />}>
      <${pascal}SubmissionsPageContent initialSettings={initialSettings} />
    </React.Suspense>
  )
}
`
}
